import { Form, useFormikContext } from 'formik';

import { Button } from '../../../cdl/Button/Button';
import { FormikCheckbox } from '../../../cdl/Checkbox/FormikCheckbox';
import { DrawerContentLayout } from '../../../cdl/Drawer/DrawerContentLayout';
import { FormikInput } from '../../../cdl/Input/FormikInput';
import { Text } from '../../../cdl/Text/Text';
import { FormikDebug } from '../../../common/form-elements/formik/FormikDebug';
import { translate } from '../../../common/helpers/translate.helper';
import { useRole } from '../../../common/hooks/useRole';
import { Box } from '../../../common/ui/Box';

import { FormikCreateCustomerGroupState } from './CreateCustomerGroupForm';

interface CustomerGroupBaseFormProps {
    primaryActionText: string;
}

export const CustomerGroupBaseForm = ({ primaryActionText }: CustomerGroupBaseFormProps) => {
    const { isSubmitting, dirty } = useFormikContext<FormikCreateCustomerGroupState>();
    const role = useRole();

    return (
        <Form style={{ height: '100%', minHeight: 0 }}>
            <DrawerContentLayout
                isBusy={isSubmitting}
                hasUnsavedChanges={dirty}
                primaryAction={
                    <Button type="submit" emphasis="high" isLoading={isSubmitting}>
                        {primaryActionText}
                    </Button>
                }
            >
                <FormikInput name="name" label={translate('global.contact.name')} markAsRequired />
                <FormikInput name="email" label={translate('company.email')} />
                <FormikInput name="phone" label={translate('company.phone')} />
                <FormikInput name="fax" label={translate('company.fax')} />

                <Text variant="subtitle1" marginTop={16}>
                    {translate('company.address')}
                </Text>

                <FormikInput name="address.companyName" label={translate('company.name')} />
                <Box display="grid" gridTemplateColumns="2fr 1fr" columnGap={16}>
                    <FormikInput name="address.street" label={translate('global.address.street')} />
                    <FormikInput name="address.streetNumber" label={translate('global.address.streetnumber')} />
                </Box>
                <Box display="grid" gridTemplateColumns="1fr 2fr" columnGap={16}>
                    <FormikInput name="address.zipcode" label={translate('global.address.zipcode')} />
                    <FormikInput name="address.city" label={translate('global.address.city')} />
                </Box>
                <FormikInput name="address.country" label={translate('global.address.country')} />

                <Text variant="subtitle1" marginTop={16}>
                    {translate('company.information')}
                </Text>

                <FormikInput
                    name="gtcUrl"
                    label={translate('company.gtc')}
                    placeholder={translate('company.placeholder.gtcUrl')}
                />

                {role.isSuperAdmin() ? (
                    <Box display="flex" flexDirection="column" rowGap={8} alignItems="flex-start">
                        <Text variant="subtitle1" marginTop={16}>
                            {translate('company.settings')}
                        </Text>

                        <FormikCheckbox name="testCompany" label={translate('company.testCompany')} />
                    </Box>
                ) : null}
                <FormikDebug />
            </DrawerContentLayout>
        </Form>
    );
};
